<input #input [(ngModel)]="selected" (keyup)="addEvent(input)">
